import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Gaze from "./Gaze";
import User from "./User"
import './App.css';

const env = 'prod'

export default function App() {
  //const id = env === 'prod' ? '00ae2989-4298-4c52-a93c-504245aa4cc2' : '7c91e630-9dc5-478e-a398-9ba813d5a0a6';
  //const otp = 'fixsocialmedia';
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  const { id, otp } = params;
  //const urlElements = window.location.href.split('/')
  //const [id, otp] = urlElements.slice(-2);
  const [gazeData, setGazeData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [view, setView] = useState('gaze') // gaze, user

  useEffect(() => {
    axios.get(`https://verse-${env}.herokuapp.com/gaze/${id}/${otp}`).then(response => {
      setGazeData(response.data);
    }).catch(console.log);
    axios.get(`https://verse-${env}.herokuapp.com/star/${id}`).then(response => {
      setUserData(response.data);
      console.log("setting user data");
      console.log(response.data);
    }).catch(console.log);
  }, [])


  const changeOrbit = (orbit, star, callback) => {
    const formattedStar = {}
    formattedStar[star.kind === 'person' ? 'people' : 'constellations'] = [{
      id: star.id,
    }];
    const body = {}
    body[orbit] = [formattedStar]
    console.log(body)
    
    axios.patch(`https://verse-${env}.herokuapp.com/gaze/${id}/${otp}`, body).then((response) => {
      setGazeData(response.data);
      window.location.reload(false);
    }).catch(console.log)
  }

  const goHome = () => {
    setView('gaze');
  }

  const showMe = () => {
    console.log("setting user view");
    setView('user');
  }

  const gazeInView = view === 'gaze' && gazeData && userData;
  const userInView = view === 'user' && userData;
  console.log(userInView);
  return (
    <div className="App">
      <Background />
      {gazeInView && <Gaze showMe={showMe} person={userData.person} data={gazeData} changeOrbit={changeOrbit} />}
      {userInView && <User data={userData} person={userData.person} goHome={goHome} />}
    </div>
  );
}

// Background

function Background() {
  return (
    <div className="background">
      <div className="bg-shooting-stars">
        {[...Array(8)].map((e, i) => <div className="shooter" key={`shooter-${i}`}></div>)}
      </div>
    </div>
  )
}